import React from 'react';
import css from './styles.module.scss';
import { Card, CardHeader, Chip, ChipProps, Grid, GridProps } from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';
import { ContactsListItem } from '~/models/contacts.dto';

type Props = GridProps & {
    contact: ContactsListItem;
    chipProps?: ChipProps;
    isManager?: boolean;
};

export const ContactCard: React.FC<Props> = ({
   contact,
   chipProps,
   isManager = false,
   ...props
}) => {

    const getChipProps = (): Partial<ChipProps> => {
        if (isManager) {
            return {
                variant: 'outlined',
                color: (contact.contactStatus || '').toLowerCase() === 'inactive' ? 'primary' : 'default',
                label: contact.contactStatus,
            };
        }
        return {
            label: contact.contactTypeDesc,
        };
    };

    const contactChipProps = getChipProps();

    return (
        <Grid item xs={12} {...props}>
            <Card elevation={0} className={css.contactCard}>
                <CardHeader
                    className={css.contactCardHeader}
                    avatar={
                        <AvatarGroup>
                            <Avatar
                                variant="square"
                                className={css.avatar}
                                alt={contact.contactName || ''}
                                src={contact.kontactImage && `${process.env.REACT_APP_ASSET}${contact.kontactImage}`}
                            />
                        </AvatarGroup>
                    }
                    title={contact.contactName || '-'}
                    action={contactChipProps.label && (
                        <Chip
                            {...contactChipProps}
                            {...chipProps}
                        />
                    )}
                />
            </Card>
        </Grid>
    );
};
